<template>
  <div class="chroma-key-background__root" :class="{ 'chroma-key-background__root--transparent': transparent }">
    <slot></slot>
  </div>
</template>

<script>
import { isPlainBrowser } from "@/utils/env-utils";

// 송출 캡처 배경 (/on-air) — 기본값 = "투명" (fail-safe):
//  - 확실한 일반 브라우저(크롬/파폭/엣지/사파리)로 판별될 때만 그린(#00ff00) — 기존 크로마키 워크플로 유지
//  - 그 외 전부(OBS/PRISM 브라우저 소스, 모르는 캡처 앱) 투명 → 크로마키 필터 불필요
//    (모바일 PRISM은 크로마키 제거 기능이 없어 투명 캡처가 유일한 방법.
//     투명이 실제로 비치려면 html/body/Vuetify 래퍼 배경까지 걷어내야 해서 mounted에서 함께 처리)
export default {
  data() {
    return { transparent: !isPlainBrowser() };
  },
  mounted() {
    if (!this.transparent) return;
    const targets = [
      document.documentElement,
      document.body,
      document.querySelector(".v-application"),
      document.querySelector(".v-application--wrap"),
    ];
    targets.forEach((el) => {
      if (el) el.style.background = "transparent";
    });
  },
};
</script>

<style scoped>
.chroma-key-background__root {
  background-color: #00ff00;
  width: 100%;
  height: 100%;
}
.chroma-key-background__root--transparent {
  background-color: transparent;
}
</style>
